import type { AsyncData, UseFetchOptions } from '#app'
import type { DefaultAsyncDataErrorValue } from 'nuxt/app/defaults'
import type { ApiFetchError } from '~/types/api.type'
import { defu } from 'defu'

export function useApiFetch<TRes, TData = TRes, TError extends ApiFetchError = ApiFetchError>(url: MaybeRefOrGetter<string>, options: UseFetchOptions<TRes, TData> = {}) {
  const { $api } = useNuxtApp()

  const defaults: UseFetchOptions<TRes, TData> = {
    deep: false,
    $fetch: $api,
    headers: useApiRequestHeaders().value,
  }

  // for nice deep defaults, please use unjs/defu
  const params = defu(options, defaults)

  // TODO: find a way to specify fetch error type without casting
  return useFetch(url, params) as AsyncData<TData, TError | DefaultAsyncDataErrorValue>
}
